"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const S = (0, tslib_1.__importStar)(require("./styles"));
const Link = ({ children, url, size = '15px', color = 'black', decoration = 'none', }) => {
    return ((0, jsx_runtime_1.jsx)(S.Anchor, Object.assign({ href: url, size: size, color: color, decoration: decoration }, { children: children }), void 0));
};
exports.default = Link;
